import { getAuthHeader } from "src/utils/authCookieParser";
import type {
  GetUserDetailsRequestProto_Body,
  GetUserDetailsResponseProto,
} from "@noom/noom-contracts/noom_contracts/backend/user/user_service";
import { appConfig } from "src/config";

export type GetUserProfileResponse = {
  accessCode: string;
  name: string;
};

/**
 * Calls the CS getUserDetails endpoint to fetch user details
 * @param accessCode - The user's access code
 * @returns Promise with user details response
 */
export async function getUserDetails(
  accessCode: string
): Promise<GetUserDetailsResponseProto> {
  const authHeader = getAuthHeader();

  const requestBody: GetUserDetailsRequestProto_Body = {
    accessCode,
  };

  const response = await fetch(
    `${appConfig.COACH_SERVER_URL}/users/getUserDetails`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader,
      },
      body: JSON.stringify(requestBody),
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to get user details: ${response.status}`);
  }

  return response.json();
}

/**
 * Calls the CS getUserProfile endpoint to fetch user profile data
 * @param accessCode - The user's access code
 * @returns Promise with user profile response or null if we fail to fetch the profile
 */
export async function getUserProfile(
  accessCode: string
): Promise<GetUserProfileResponse | null> {
  try {
    const authHeader = getAuthHeader();

    const response = await fetch(
      `${appConfig.COACH_SERVER_URL}/users/${accessCode}/profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...authHeader,
        },
      }
    );

    if (!response.ok) {
      return null;
    }

    return response.json();
  } catch (error) {
    return null;
  }
}
